<template>
  <div class="container-fluid">
    <bounce-loader :loading="loading"></bounce-loader>
    <div class="row" v-if="data">
      <div class="col-md-12">
        <h1 id="proy-code" class="pull-left">{{ codigo_proyecto }}</h1>
        <img id="proy-img"  class="pull-right" :src="data.logo_imagen.url" v-if="data.logo_imagen">
        
        <div class="clearfix"></div>
        
        <h3>{{ data.nombre_proyecto }}</h3>
        <p>{{ data.descripcion_proyecto }}</p>
        
        <div class="clearfix"></div>
      </div>
      <div class="col-md-12">
        <h3>Equipo</h3>
        <table class="table table-bordered table-condensed proy-equipo">
          <tr><th>Rol</th><th>Nombre</th><th>Apellido</th><th class="hidden-xs">Mail</th><th class="hidden-xs">Telefono</th><th class="visible-xs">&nbsp;</th></tr>
          <tr v-for="item in data.usuarios">
            <td>{{ getNombreRolPorCodigo(item.role) }}</td>
            <td>{{ item.nombre }}</td>
            <td>{{ item.apellido }}</td>
            <td class="hidden-xs"><a :href="'mailto:'+item.email" style="color:#333;">{{ item.email }}</a></td>
            <td class="hidden-xs"><a :href="'tel:+'+item.tel" style="color:#333;">{{ item.tel }}</a></td>
            <td class="visible-xs">
              <a v-if="item.email" :href="'mailto:'+item.email" style="color:#333;" class="ico-equipo">
                <i class="fa fa-envelope"></i>
              </a> 
              <div class="clearfix visible-xs"></div>             
              <a v-if="item.tel" :href="'tel:+'+item.tel" style="color:#333;" class="ico-equipo">
                <i class="fa fa-phone"></i>
              </a>
            </td>
          </tr>
        </table>        
      </div>
      <div class="col-md-12">
        <h3>Ubicación</h3>
        <mapa-proyecto v-if="data" :lat="data.latitud" :lng="data.longitud"></mapa-proyecto>
      </div>
    </div>
    <div class="row" v-if="error">
      <div class="col-md-6">
        <h1 id="proy-code" class="pull-left">{{ codigo_proyecto }}</h1>
      </div>        
      <div class="col-xs-12 text-center">
        {{ error }}
      </div>
    </div>
    <div class="visible-xs visible-sm" style="height:25%;">&nbsp;</div>
  </div>
</template>
<script>
// import { EventBus } from '../../core/event-bus.js'
import api from '../../../api'
import { mapGetters } from 'vuex'
import MapaProyecto from './Mapa'
export default {
  name: 'ProyectoInfo',
  components: {
    MapaProyecto
  },
  props: ['codigo_proyecto'],
  computed: {
    ...mapGetters([
      'getNombreRolPorCodigo'
    ])
  },
  data () {
    return {
      data: null,
      error: null,
      loading: true
    }
  },
  mounted () {
    let vm = this
    api.getProyectoInfo(this.codigo_proyecto).then(data => {
      vm.data = data
      vm.loading = false
    }, error => {
      vm.error = error.message
      vm.loading = false
    })
  }
}
</script>
<style scoped>
  h1#proy-code {
    margin-top: 20;
  }

  img#proy-img {
    max-height: 80px;
  }

  table.proy-equipo {
    border: none;
  }

  table.proy-equipo tr{
    height: 50px;
  }
  table.proy-equipo .ico-equipo{
    color:#333;
    padding: 3px 4px;
    display: block;
  }
  table.proy-equipo th{
    background: #ccc;
  }
  table.proy-equipo tr:nth-child(odd) {
    background: #ddd;
  }  
  table.proy-equipo td:first-child, table.proy-equipo th:first-child {
    padding-left: 10px;
  }
</style>


// WEBPACK FOOTER //
// src/components/views/proyectos/Info.vue